import styled from 'styled-components/macro';

const Seperator = styled.hr`
  border: 1px solid ${props => props.theme.colors.borderLighter};
`;

export default Seperator;
